import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useMemo } from 'react';

var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7824 14.1068L10.7896 4.10358C10.053 2.62782 7.9472 2.6278 7.21059 4.10357L2.21763 14.1068C1.55392 15.4365 2.52095 17 4.0071 17H13.9929C15.479 17 16.4461 15.4366 15.7824 14.1068ZM12.579 3.21041C11.1059 0.258875 6.89432 0.258861 5.42112 3.21038L0.428157 13.2136C-0.89926 15.8731 1.03478 19 4.0071 19H13.9929C16.9652 19 18.8992 15.8731 17.5719 13.2137L12.579 3.21041Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6V10C8 10.5523 8.44772 11 9 11C9.55228 11 10 10.5523 10 10V6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13Z",
      fill: "#12131A"
    })]
  }));
};

WarningIcon.defaultProps = {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Notice = _ref => {
  let {
    text,
    type = 'info',
    variant: srcVariant = '',
    className = '',
    children
  } = _ref;
  const isWarning = type === 'warning';
  const isInfo = type === 'info';
  const variantClasses = useMemo(() => {
    const variants = Array.isArray(srcVariant) ? srcVariant : [srcVariant];
    return variants.filter(Boolean).map(variant => styles[`container--${variant}`]);
  }, [srcVariant]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, ...variantClasses, styles[`container--${type}`], className),
    children: [isWarning && /*#__PURE__*/_jsx(WarningIcon, {
      className: styles.container__icon
    }), isInfo && /*#__PURE__*/_jsx(InfoIcon, {
      className: styles.container__icon
    }), /*#__PURE__*/_jsxs("p", {
      className: styles.container__text,
      children: [text, children]
    })]
  });
};

export default Notice;